import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-cream energy-glow-light py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-94" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-95" data-mp="9srx3i7vy45b">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-line bg-white p-8 shadow-card sm:p-12" data-id="element-96" data-mp="etz5njhur7d1">
          <span className="inline-flex rounded-full bg-sage p-4 text-white" data-id="element-97" data-mp="sm5hitdz2s6o">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-98" data-mp="xk73bm2s95lu" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-ink" data-id="element-99" data-mp="12jjzixfjnp13">
            Garantía total de 7 días
          </h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-100" data-mp="17imt9lq2q8tr">
            Abre los 9 tomos. Revisa los 5 bonos. Úsalos en tu clase más difícil esta semana. Si sientes que tus alumnos
            no respondieron mejor, o que el material no te ahorró horas de trabajo:
          </p>
          <p className="mt-6 rounded-lg bg-sageSoft px-5 py-4 text-lg font-extrabold text-forestSoft" data-id="element-101" data-mp="1vuskyhwbeofj">
            Te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios. Sin complicaciones.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-muted" data-id="element-102" data-mp="2oh3n3wzkkxeg">
            Porque si el material no te da el valor que prometemos, no queremos quedarnos con tu dinero.
          </p>
        </motion.div>
      </div>
    </section>;
}